import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faBookOpen,
  faHyphen,
  faTicket,
  faCertificate,
  faCalendarDay,
  faCalendarDays,
  faChartMixed,
  faShop,
  faUserGroup,
  faIdCardClip,
  faDiceD20,
  faRankingStar,
  faUserPlus,
  faUser,
  faList,
  faListUl,
  faMagnifyingGlass,
  faGear,
  faRectangleHistory,
  faRotateRight,
  faRectangleVerticalHistory,
  faRectangleHistoryCirclePlus,
  faDownToLine,
  faBoxOpen,
  faPage,
  faBagShopping,
  faShapes,
  faCartShopping,
  faTag,
  faTags,
  faSquarePlus,
  faHouse,
  faBars,
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
  faAngleDown,
  faAnglesDown,
  faAngleUp,
  faAnglesUp,
  faCircleCheck,
  faEllipsis,
  faEllipsisVertical,
  faXmark,
  faLocationDot,
  faSparkles,
  faCalendarWeek,
  faGlobe,
  faGripLines,
  faArrowDownShortWide,
  faArrowDownWideShort,
  faArrowRightToBracket,
  faShareNodes,
  faShare,
  faStar,
  faFill,
  faHandshake,
  faClipboardList,
  faIdBadge,
  faUsers,
  faUsersViewfinder,
  faCodeBranch,
  faTrophy,
  faRotateLeft,
  faPen,
  faCopy,
  faWrench,
  faFilter,
  faCircleInfo,
  faLayerGroup,
  faArrowRightFromBracket,
  faCircleQuestion,
  faCirclePlay,
  faLoveseat,
  faListOl,
  faCaretUp,
  faCaretDown,
  faShield,
  faMerge,
  faCircleUser,
  faCardsBlank,
  faUserGear,
  faLinkSimple,
  faLinkSlash,
  faEnvelope,
  faCirclePause,
  faUpFromLine,
  faDollarSign,
  faDollarCircle,
  // faTrashXmark,
  faStopwatch,
  faUserMagnifyingGlass,
  faCircleXmark,
  faFloppyDisk,
  faEye,
  faPlus,
  faMinus,
  faTrash,
  faLockKeyhole,
  faLockKeyholeOpen,
  faArrowLeft,
  faCirclePlus,
  faArrowUpArrowDown,
  faTriangleExclamation,
  faImageSlash,
  faSun,
  faMoon,
  faNetworkWired,
  faMedal,
  faBarsStaggered,
  faFilterSlash,
  faSliders,
  faCircle1,
  faCircle2,
  faCircle3,
  faCircle4,
  faArrowsLeftRight,
  faArrowDownRight,
  faArrowDownLeft,
  faSignalStream,
  faBarsSort,
  faRoad,
  faTimer,
  faArrowRight,
  faCircleStar,
  faDiceFive,
  faMoneyBillSimple,
  faCommentQuestion,
  faUserTie,
  faBookmark,
  faRectanglesMixed,
  faArrowLeftFromBracket,
  faArrowLeftToBracket,
  faCodeSimple,
  faBuildingColumns,
  faMoneyBills,
  faCheck,
  faBadgeCheck,
  faPhone,
  faMap,
  faMapLocation,
  faFlag,
  faClock,
  faArrowUpFromBracket,
  faDisplay,
  faLightbulb,
  faEyeSlash,
  faCompress,
  faExpand,
  faChair,
  faPrint
} from "@fortawesome/sharp-solid-svg-icons";
import {
  faFacebook,
  faTwitter,
  faXTwitter,
  faInstagram,
  faYoutube,
  faDiscord,
  faTwitch,
  faThreads
} from "@fortawesome/free-brands-svg-icons";

import {
  faCircleArrowUp,
  faCircleArrowDown,
  faCircleMinus,
  faQrcode,
  faStar as faStarOutline,
  faLockKeyhole as faLockKeyholeOutline,
  faLockKeyholeOpen as faLockKeyholeOpenOutline,
  faCircle1 as faCircle1OutLine,
  faCircle2 as faCircle2Outline,
  faCircle3 as faCircle3Outline,
  faCircle4 as faCircle4Outline,
  faUser as faUserOutline,
  faUsers as faUsersOutline,
  faUserGroup as faUserGroupOutline,
  faBookmark as faBookmarkOutline,
  faRectanglesMixed as faRectanglesMixedOutline,
  faClipboardList as faClipfaClipboardListOutline
} from "@fortawesome/sharp-regular-svg-icons";

const defaultSize = 22;

export const getIconSize = (size) => {
  switch (size) {
    case "extra-small":
    case "xs":
      return "10px";

    case "small":
    case "sm":
      return "16px";

    case "medium":
    case "md":
      return "22px";

    case "large":
    case "lg":
      return "28px";

    case "extra-large":
    case "xl":
      return "34px";

    default:
      return typeof size === "number"
        ? `${size}px`
        : typeof size === "string"
          ? size
          : `${defaultSize}px`;
  }
};

export function BCPDollarCircle(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faDollarCircle}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPDollarSign(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faDollarSign}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPMedal(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faMedal}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPBrackets(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faNetworkWired}
      rotation={90}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPDash(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faHyphen}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPAngleDown(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faAngleDown}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPAnglesDown(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faAnglesDown}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPAngleRight(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faAngleRight}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPAnglesRight(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faAnglesRight}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPAngleLeft(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faAngleLeft}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPAnglesLeft(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faAnglesLeft}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPAngleUp(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faAngleUp}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPAnglesUp(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faAnglesUp}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPArrowDownLeft(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowDownLeft}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPArrowDownRight(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowDownRight}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPArrowLeft(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowLeft}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPArrowRight(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowRight}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPArrowRightToBracket(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowRightToBracket}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPArrowRightFromBracket(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowRightFromBracket}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPArrowLeftFromBracket(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowLeftFromBracket}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPArrowLeftToBracket(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowLeftToBracket}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPArrowsLeftRight(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowsLeftRight}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPArrowUpArrowDown(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowUpArrowDown}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPArrowUpFromBracket(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowUpFromBracket}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPBadgeCheck(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faBadgeCheck}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPBagShopping(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faBagShopping}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPBank(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faBuildingColumns}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPBars(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faBars}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPBarsSort(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faBarsSort}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPBook(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faBook}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPBookmark(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={outlined ? faBookmark : faBookmarkOutline}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPBookOpen(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faBookOpen}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPBoxOpen(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faBoxOpen}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCalendarDay(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCalendarDay}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCalendarDays(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCalendarDays}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCalendarWeek(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCalendarWeek}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCardsBlank(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCardsBlank}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCaretDown(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCaretDown}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCaretUp(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCaretUp}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCartShopping(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCartShopping}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCertificate(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCertificate}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPChartMixed(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faChartMixed}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCheck(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCheck}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircle1(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={outlined ? faCircle1OutLine : faCircle1}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircle2(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={outlined ? faCircle2Outline : faCircle2}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircle3(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={outlined ? faCircle3Outline : faCircle3}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircle4(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faCircle4}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircle4Outline(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faCircle4Outline}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircleArrowDown(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCircleArrowDown}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircleMinus(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCircleMinus}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircleArrowUp(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCircleArrowUp}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircleCheck(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCircleCheck}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircleInfo(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCircleInfo}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCirclePause(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCirclePause}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCirclePlay(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCirclePlay}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCirclePlus(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCirclePlus}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircleStar(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCircleStar}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircleQuestion(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCircleQuestion}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircleUser(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCircleUser}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCircleXmark(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCircleXmark}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPClipboardList(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={outlined ? faClipfaClipboardListOutline : faClipboardList}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPClock(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faClock}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCodeBranch(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCodeBranch}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCodeSimple(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCodeSimple}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCommentQuestion(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCommentQuestion}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCompress(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCompress}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPCopy(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faCopy}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPDiscord(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faDiscord}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPDownToLine(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faDownToLine}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPDiceD20(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faDiceD20}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPDiceFive(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faDiceFive}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPDisplay(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faDisplay}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPEllipsis(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faEllipsis}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPEllipsisVertical(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faEllipsisVertical}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPEnvelope(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faEnvelope}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPExpand(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faExpand}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPEye(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faEye}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPEyeSlash(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faEyeSlash}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPFacebook(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faFacebook}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPFlag(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faFlag}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPFloppyDisk(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faFloppyDisk}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPHandshake(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faHandshake}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPHouse(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faHouse}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPImageSlash(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faImageSlash}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPFill(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faFill}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPFilter(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faFilter}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPFilterSlash(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faFilterSlash}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPGear(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faGear}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPGlobe(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faGlobe}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPGripLines(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faGripLines}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPIdBadge(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faIdBadge}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPIdCardClip(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faIdCardClip}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPInstagram(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faInstagram}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPLayerGroup(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faLayerGroup}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPLightbulb(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faLightbulb}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPLinkSimple(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faLinkSimple}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPLinkSlash(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faLinkSlash}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPList(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faList}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPListOl(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faListOl}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPListUl(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faListUl}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPLocationDot(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faLocationDot}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPLockKeyhole(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={outlined ? faLockKeyholeOutline : faLockKeyhole}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPLockKeyholeOpen(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={outlined ? faLockKeyholeOpenOutline : faLockKeyholeOpen}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPLockOutline(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faLockKeyholeOutline}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPLoveseat(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faLoveseat}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPMap(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faMap}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPMapLocationDot(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faMapLocation}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPMerge(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faMerge}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPMinus(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faMinus}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPMoneyBills(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faMoneyBills}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPMoneyBillsSimple(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faMoneyBillSimple}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPMoon(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faMoon}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPPage(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faPage}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPPen(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faPen}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPPhone(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faPhone}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPPlus(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faPlus}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPPrint(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faPrint}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPQrcode(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faQrcode}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPRankingStar(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faRankingStar}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPRectangleHistory(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faRectangleHistory}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPRectangleHistoryCirclePlus(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faRectangleHistoryCirclePlus}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPRectanglesMixed(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={outlined ? faRectanglesMixedOutline : faRectanglesMixed}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPRectangleVerticalHistory(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faRectangleVerticalHistory}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPReorder(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faBarsStaggered}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPRoad(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faRoad}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPRotateLeft(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faRotateLeft}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPRotateRight(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faRotateRight}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPSearch(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size || 18);

  return (
    <FontAwesomeIcon
      icon={faMagnifyingGlass}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPShapes(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faShapes}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPShare(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faShare}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPShareNodes(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faShareNodes}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPShield(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faShield}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPShop(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faShop}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPSignalStream(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faSignalStream}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPSliders(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faSliders}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPSortAmountDownAsc(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowDownShortWide}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPSortAmountDownDesc(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faArrowDownWideShort}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPSparkles(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faSparkles}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPSquarePlus(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faSquarePlus}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPStar(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={outlined ? faStarOutline : faStar}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPStopwatch(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faStopwatch}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPSun(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faSun}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPTag(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faTag}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPTags(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faTags}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPTicket(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faTicket}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPTimer(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faTimer}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPTrash(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faTrash}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPTriangleExclamation(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faTriangleExclamation}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPTrophy(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faTrophy}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPTwitch(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faTwitch}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPTwitter(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faTwitter}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPTwitterX(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faXTwitter}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPUpFromLine(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faUpFromLine}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPUser(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={outlined ? faUserOutline : faUser}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}
export function BCPUserOutline(props) {
  const { sx, style, ...rest } = props;
  return (
    <FontAwesomeIcon
      icon={faUserOutline}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPUserGear(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faUserGear}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPUsers(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={outlined ? faUsersOutline : faUsers}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPUserTie(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faUserTie}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPUsersViewfinder(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faUsersViewfinder}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPUserGroup(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={outlined ? faUserGroupOutline : faUserGroup}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPUserMagnifyingGlass(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faUserMagnifyingGlass}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPUserPlus(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faUserPlus}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPWrench(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faWrench}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPYoutube(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faYoutube}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPThreads(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faThreads}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPXmark(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faXmark}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

export function BCPChair(props) {
  const { sx, style, ...rest } = props;

  return (
    <FontAwesomeIcon
      icon={faChair}
      style={{
        fontSize: `${defaultSize}px`,
        width: `${defaultSize}px`,
        ...style,
        ...sx
      }}
      {...rest}
    />
  );
}

// export function BCPCircleCheckOutline(props) {
//   const { sx, style, ...rest } = props;

//   return (
//     <FontAwesomeIcon
//       icon={faCircleCheckOutline}
//       style={{
//         "fontSize": "22px",
//         width: "22px",
//         ...style,
//         ...sx,
//       }}
//       {...rest}
//     />
//   );
// }

// export function BCPArrowRotateLeft(props) {
//   const { sx, style, ...rest } = props;
//   return (
//     <FontAwesomeIcon
//       icon={faArrowRotateLeft}
//       style={{
//         "fontSize": "22px",
//         width: "22px",
//         ...style,
//         ...sx,
//       }}
//       {...rest}
//     />
//   );
// }

// export function BCPTrashXmark(props) {
//   const { sx, style, ...rest } = props;
//   return (
//     <FontAwesomeIcon
//       icon={faTrashXmark}
//       style={{
//         "fontSize": "22px",
//         width: "22px",
//         ...style,
//         ...sx,
//       }}
//       {...rest}
//     />
//   );
// }

// export function BCPQuestion(props) {
//   const { sx, style, ...rest } = props;
//   return (
//     <FontAwesomeIcon
//       icon={faQuestion}
//       style={{
//         "fontSize": "22px",
//         width: "22px",
//         ...style,
//         ...sx,
//       }}
//       {...rest}
//     />
//   );
// }
